<h1 mat-dialog-title>{{ data.title }}</h1>
<mat-dialog-content class="dialog-body">
  @for (dropdown of data.dropdowns; track dropdown) {
    <mat-form-field appearance="outline">
      <mat-label>{{ dropdown.label }}</mat-label>
      <mat-select [(value)]="selectedOptions[dropdown.key]">
        @for (option of dropdown.options; track option) {
          <mat-option [value]="option">
            {{ option }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button mat-dialog-close color="accent">Close</button>
  <button
    mat-flat-button
    color="primary"
    [disabled]="!isSubmitEnabled()"
    (click)="onSubmit()"
  >
    Submit
  </button>
</mat-dialog-actions>
